import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoopIcon from '@mui/icons-material/Loop';
import { Button, useMediaQuery } from '@mui/material';
import { useAuth } from 'context/Auth/AuthContext';
import { Form, Formik, FormikHelpers } from 'formik';
import routes from 'routes';
import { FormInput } from 'components';
import { recoveryInitial, recoveryValidation } from './constants';
import { StyledField, StyledForgotPasswordButton, StyledLink, StyledSimpleText } from 'pages/Authentication/SignIn/styled';
import theme, { animations } from 'themes';
import { FormValues } from 'features/Authentication/PasswordRecovery/types';

// Define the shape of the form values.

const PasswordRecoveryAmplify: React.FC = () => {
  const { passwordRecovery } = useAuth();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSubmit = async (
    values: FormValues,
    { setSubmitting }: FormikHelpers<FormValues>
  ) => {
    try {
      await passwordRecovery(values.email);
      navigate('/authentication/password-reset', {
        state: {
          username: values.email,
        },
      });
    } catch (err) {
      setSubmitting(false);
    }
  };
  return (
    <Formik<FormValues>
      initialValues={recoveryInitial}
      validationSchema={recoveryValidation}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
          <Form>
            <StyledField
              name='email'
              label='Email'
              component={FormInput}
              margin={'normal'}
            />
            <Button
              fullWidth
              size='large'
              type='submit'
              variant='contained'
              disabled={isSubmitting}
              sx={{ mt: 2, mb: 2, textTransform: 'capitalize' }}
            >
              {isSubmitting && <LoopIcon sx={{ animation: `${animations.spin} 2s linear infinite` }} />}
              Get Reset Link
            </Button>

              {isMobile ? (
                <StyledForgotPasswordButton
                  size='large'
                  fullWidth
                  variant='contained'
                  onClick={() => navigate(routes.auth.logIn)}
                >
                  Go back
                </StyledForgotPasswordButton>
              ) : (
                <StyledSimpleText>
                  Remembered your password?
                  <StyledLink href={routes.auth.logIn}>Login Here</StyledLink>
                </StyledSimpleText>
              )}
          </Form>
        )}
    </Formik>
  );
};

export default PasswordRecoveryAmplify;
